import type { Timeseries } from '../../../core/types/timeseries.js';
import type { PointsDisplay, GapPolicy } from '../../types/timeseries-props.js';
import type { TimeseriesChartVisualProps } from '../../types/timeseries.js';

/**
 * Props for the TimeseriesChart.Area slot component
 * @public
 */
export interface TimeseriesChartAreaProps extends TimeseriesChartVisualProps {
  /** The series data passed to the area */
  data: Timeseries;
  /** Defines how gaps are handled (connect vs. gap) */
  gapPolicy?: GapPolicy;
  /** Whether to show data points always, never, or depending on a width-based threshold amount */
  pointsDisplay?: PointsDisplay;
}

/**
 * @public
 */
export const Area = (props: TimeseriesChartAreaProps) => null;

Area['displayName'] = 'TimeseriesChart.Area';
